import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import ReactPixel from "react-facebook-pixel"
import TagManager from 'react-gtm-module'


const usePageTracking = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);
  
  const tagManagerArgs = {
    gtmId: 'GTM-PGFPQ5KT'
  }

  useEffect(() => {
    if (!window.location.href.includes("localhost")) {
      ReactGA.initialize("G-21ZVNSTFGM");
      ReactPixel.init('408252831132089');
      TagManager.initialize(tagManagerArgs)
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (initialized) {
      ReactPixel.pageView(location.pathname + location.search);
    }
  }, [initialized, location]);
};

export default usePageTracking;